export default __webpack_public_path__ + "static/media/header1-min.3a8cad64.jpg";